import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { classNames } from "primereact/utils";
import "./AlumniUniversite.scss";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { Checkbox } from "primereact/checkbox";
import { useFetchGetConditional } from "Services/api";
import Loader from "Components/Loader/loader";
import ModalCharte from "Components/Modal/ModalCharte/ModalCharte";
import axios from "axios";
// import { Password } from "primereact/password";
import { DateTime } from "luxon";
import { useEffect } from "react";
import { addLocale, locale } from "primereact/api";
import { getFrenchLocale } from "Components/Stats/Data/Const";
import Input from "react-phone-number-input/input";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import data from "assets/countries";
import { updateSecondaryTables } from "Redux/Actions/secondaryTablesActions";
import { updateAuth } from "../../../../Redux/Actions/authActions";
import {Password} from "primereact/password";

const AlumniUniversite = (props) => {
    addLocale("fr", getFrenchLocale().fr);
    locale("fr");
    const niveauDiplomeData = useFetchGetConditional(
        "/level_of_educations",
        props.auth.token,
        props.secondaryTables.levelOfEducationsData
    );
    const [visibleModalCharte, setvisibleModalCharte] = useState(false);
    const [isStudent, setIsStudent] = useState(true);
    const [isAlumniForgot, setIsAlumniForgot] = useState(false);

    useEffect(() => {
        niveauDiplomeData.loaded &&
        props.handleUpdateSecondaryTables({
            levelOfEducationsData: niveauDiplomeData.data,
        });
    }, [niveauDiplomeData.loaded]);
    // si le formulaire est utilisé au moment de la création de compte on prend des valeurs de base nulles
    // si le formulaire est utilisé au moment de la modification de profil on prend les valeurs de l'utilisateur
    function valeursFinales() {
        if (props.utilisateur == undefined) {
            return defaultValues;
        } else {
            defaultValues.email = props.utilisateur.email;
            return defaultValues;
        }
    }
    const [message, setMessage] = useState({
        detail: "",
        header: "",
        type: "",
        visible: false,
    });

    // constantes de l'utilisateur
    let defaultValues = {
        surname: "",
        firstname: "",
        universite: props.chosenUniversity,
        // password: "",
        // confirmPassword: "",
        promotionYear: null,
        niveauDiplome: "",
        email: "",
        birthday: "",
        telephone: "",
        country: "France",
        motivation: "",
        accept: false,
        student: false,
        alumni: false,
    };
    valeursFinales();

    const {
        control,
        formState: { errors },
        handleSubmit,
        setValue,
        getValues,
        watch,
        trigger,
    } = useForm({ defaultValues });

    useEffect(() => {}, [watch("promotionYear"), watch("birthday")]);

    const sendRequestAlumni = (data) => {
        let response = null;
        axios
            .post(
                `${process.env.REACT_APP_BASE_URL_USPN_API}/send-email-before-validate`,
                data,
                {
                    headers: props.auth.token
                        ? {
                            accept: "application/json",
                            Authorization: `Bearer ${props.auth.token}`,
                        }
                        : {
                            accept: "application/json",
                        },
                }
            )
            .then((res) => {
                response = res;
            })
            .catch((err) => {
                console.log(err);
                setMessage({
                    type: "error",
                    visible: true,
                });
                props.auth.toast?.current?.show({
                    severity: "error",
                    summary: "Erreur",
                    detail: err?.response?.data?.detail || "Une erreur est survenue",
                    life: 5000,
                });
            })
            .finally(() => {
                if (response) {
                    setMessage({
                        type: "success",
                        visible: true,
                    });
                }
            });
    };

    /*const sendRequest = (data) => {
        // Variable qui stockera la réponse du serveur
        let response = null;
        // On crée un FormData qui sera envoyé au serveur
        var dataForm = new FormData();
        // On ajoute les données du formulaire au formData
        for (var key in data) dataForm.append(key, data[key]);

        axios
            .post(`${process.env.REACT_APP_BASE_URL_API}/users`, dataForm, {
                headers: props.auth.token
                    ? {
                        accept: "application/json",
                        Authorization: `Bearer ${props.auth.token}`,
                    }
                    : {
                        accept: "application/json",
                    },
            })
            .then((res) => {
                response = res;
            })
            // Si il y a une erreur:
            .catch((err) => {
                props.auth.toast?.current?.show({
                    severity: "error",
                    summary: "Erreur",
                    detail: err?.response?.data?.detail || "Une erreur est survenue",
                    life: 5000,
                });
            })
            // Si tout s'est bien passé, on affiche un message de succès
            .finally(() => {
                if (response) {
                    setMessage({
                        detail: response.data.message,
                        header: "Succès",
                        type: "success",
                        visible: true,
                    });
                }
            });
    };*/

    const handleCheckboxChange = (type: "student" | "alumni", checked: boolean) => {
        if (type === "student") {
            setValue("student", checked);
            setValue("alumni", !checked);
            setIsStudent(checked);
            setIsAlumniForgot(!checked);
        } else {
            setValue("alumni", checked);
            setValue("student", !checked);
            setIsAlumniForgot(checked);
            setIsStudent(!checked);
        }
    };

    /**
     * Fonction qui remplit les dates du formulaire
     * @param {{}} data - Données du formulaire
     * @returns {{}} - Données du formulaire avec les dates remplies
     */
    const fillDates = (data) => {
        if (data.promotionYear)
            data.promotionYear = data.promotionYear.getFullYear();
        if (data.birthday) data.birthday = data.birthday.toISOString();
        return data;
    };

    /**
     * Fonction qui supprime les champs vides|null du formulaire
     * @param {{}} data - Données du formulaire
     * @returns {{}} - Données du formulaire sans les champs vides|null
     */
    const removeEmpty = (data) => {
        for (var key in data) {
            if (data[key] == null || data[key] == "") {
                delete data[key];
            }
        }
        return data;
    };

    const fillAlumni = (data) => {
        let newData = {
            alumniFirstname: data.firstname,
            alumniSurname: data.surname,
            alumniEmail: data.email,
            alumniCountry: data.country,
            alumniTelephone: data.telephone ? data.telephone : null,
            validated: false,
            membershipRequestReason: data?.motivation,
            levelOfEducation: data.niveauDiplome
                ? "/api/level_of_educations/" + data.niveauDiplome.id
                : null,
            birthday: data.birthday ? data.birthday : null,
            university: "/api/university/2",
            graduationYear: data.promotionYear ? data.promotionYear.toString() : null,
        };
        return newData;
    };

    const onSubmit = () => {
        var data = getValues();
        data = removeEmpty(data);
        data = fillDates(data);
        if (getValues("student") == false) {
            data = fillAlumni(data);
            sendRequestAlumni(data);
        } else {
            sendLoginRequest(data);
        }
    };

    const getFormErrorMessage = (name) => {
        return (
            errors[name] && <small className="p-error">{errors[name].message}</small>
        );
    };

    const sendLoginRequest = async (data) => {
        try {
            // 1. Auth principale
            await axios.post(
                `${process.env.REACT_APP_BASE_URL_API}/login_check`,
                { username: data.login, password: data.password },
                {
                    headers: props.auth.token
                        ? {
                            accept: "application/json",
                            Authorization: `Bearer ${props.auth.token}`,
                        }
                        : {
                            accept: "application/json",
                        },
                }
            );

            // 2. Auth secondaire USPN
            const uspnResponse = await axios.post(
                `${process.env.REACT_APP_BASE_URL_USPN_API}/alumni_login`,
                { username: data.login, password: data.password },
                {
                    headers: props.auth.token
                        ? {
                            accept: "application/json",
                            Authorization: `Bearer ${props.auth.token}`,
                        }
                        : {
                            accept: "application/json",
                        },
                }
            );

            // 3. Stocker le token si tout est OK
            if (uspnResponse?.status === 200 && uspnResponse.data?.token) {
                document.cookie = `t=${uspnResponse.data.token}; path=/;`;
            }

            window.location.href = process.env.REACT_APP_BASE_URL_USPN;

        } catch (err) {
            setMessage({
                type: "error",
                visible: true,
            });
            // TODO: Afficher une erreur plus précise
            /*props.auth.toast?.current?.show({
                severity: "error",
                summary: "Erreur",
                detail: "Email ou mot de passe incorrect.",
                life: 5000,
            });*/
        }
    };

    const dialogFooter = (
        <div className="flex justify-content-center">
            <Button
                label="OK"
                className="p-button-text"
                autoFocus
                onClick={() => {
                    setMessage({ ...message, visible: false });
                    if (message.type == "success") {
                        props.setVisibleUniv(false);
                        if (props.setChosenUniversity) {
                            props.setChosenUniversity(null);
                        }
                        props.setVisibleModalGlobal && props.setVisibleModalGlobal(false);
                    } else setMessage({ ...message, visible: false });
                }}
            />
        </div>
    );

    return (
        <div className="form-demo">
            <Dialog
                appendTo={document.getElementById("app")}
                visible={message.visible}
                onHide={() => setMessage({ ...message, visible: false })}
                position="top"
                footer={dialogFooter}
                showHeader={false}
                breakpoints={{ "960px": "80vw" }}
                style={{ width: "30vw" }}
            >
                <div className="flex justify-content-center flex-column pt-6 px-3">
                    <i
                        className={
                            message.type == "success"
                                ? "pi pi-check-circle"
                                : "pi pi-times-circle"
                        }
                        style={{
                            fontSize: "4rem",
                            color:
                                message.type == "success"
                                    ? "var(--green-500)"
                                    : "var(--red-500)",
                            margin: "1rem",
                        }}
                    ></i>
                    <h5></h5>
                    <p style={{ lineHeight: 1.5 }}>
                        <br />
                        {message.type == "success" ? (
                            <>
                                Votre compte est enregistré sous le nom de{" "}
                                <b>{getValues("firstname")}</b> <b>{getValues("surname")}</b>.
                                <br />
                                <br />
                                Un mail vous sera envoyé à <b>{getValues("email")}</b> une fois
                                votre compte activé.
                            </>
                        ) : (
                            <div>
                                Une erreur est survenue lors de la création de votre compte.
                                <br />
                                Veuillez réessayer ultérieurement.
                            </div>
                        )}
                    </p>
                </div>
            </Dialog>

            <div className="card">
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
                    <div className="field">
                        <div className="checkboxes">
                            <div className="field checkbox">
                                <Controller
                                    name="student"
                                    control={control}
                                    render={({ field }) => (
                                        <Checkbox
                                            className="checkbox_student"
                                            id={field.name}
                                            checked={field.value}
                                            onChange={(e) => {
                                                field.onChange(e.checked);
                                                handleCheckboxChange("student", e.checked);
                                            }}
                                        />
                                    )}
                                />
                                <label htmlFor="student">J&apos;ai déjà un compte< /label>
                                {getFormErrorMessage("student")}
                            </div>
                            <div className="field checkbox">
                                <Controller
                                    name="alumni"
                                    control={control}
                                    render={({ field }) => (
                                        <Checkbox
                                            className="checkbox_alumni"
                                            id={field.name}
                                            checked={field.value}
                                            onChange={(e) => {
                                                field.onChange(e.checked);
                                                handleCheckboxChange("alumni", e.checked);
                                            }}
                                        />
                                    )}
                                />
                                <label htmlFor="alumni">Je crée mon compte</label>
                                {getFormErrorMessage("alumni")}
                            </div>
                        </div>
                    </div>

                    {isAlumniForgot && (
                        <div className="register_alumni">
                            <div className="ask_connexion_name">
                                <div className="field">
                                    <h2>Nom *</h2>
                                    <Controller
                                        name="surname"
                                        control={control}
                                        rules={{ required: "Le nom est requis" }}
                                        render={({ field, fieldState }) => (
                                            <InputText
                                                id={field.name}
                                                placeholder="Dupont..."
                                                {...field}
                                                autoFocus
                                                className={classNames({
                                                    "p-invalid": fieldState.invalid,
                                                })}
                                            />
                                        )}
                                    />
                                    {getFormErrorMessage("surname")}
                                </div>
                                <div className="field">
                                    <h2>Prénom *</h2>
                                    <Controller
                                        name="firstname"
                                        control={control}
                                        rules={{ required: "Le prénom est requis" }}
                                        render={({ field, fieldState }) => (
                                            <InputText
                                                id={field.name}
                                                {...field}
                                                placeholder="Marie, Arthur..."
                                                //   autoFocus
                                                className={classNames({
                                                    "p-invalid": fieldState.invalid,
                                                })}
                                            />
                                        )}
                                    />
                                    {getFormErrorMessage("firstname")}
                                </div>
                            </div>
                            <div className="ask_connexion_country">
                                <div className="field">
                                    <h2>Date de naissance</h2>
                                    <Controller
                                        name="birthday"
                                        control={control}
                                        rules={{
                                            required: "La date de naissance est requise",
                                            validate: (value) =>
                                                !isNaN(Date.parse(value)) ||
                                                "La date de naissance n'est pas valide",
                                        }}
                                        render={(field) => (
                                            <Calendar
                                                id={field.name}
                                                {...field}
                                                onChange={(e) => setValue("birthday", e.value)}
                                                className="p-inputtext p-component"
                                                showIcon
                                                readOnlyInput={false}
                                                dateFormat="dd/mm/yy"
                                                maxDate={DateTime.local().toJSDate()}
                                            />
                                        )}
                                    />
                                </div>

                                <div className="field">
                                    <h2 htmlFor="country">Pays</h2>
                                    <Controller
                                        name="country"
                                        control={control}
                                        rules={{ required: "Le pays est requis" }}
                                        render={({ field }) => (
                                            <Dropdown
                                                id={field.name}
                                                {...field}
                                                onChange={(e) => field.onChange(e.value)}
                                                placeholder="France, Belgique..."
                                                options={data}
                                                className="box__input"
                                            />
                                        )}
                                    />
                                    {getFormErrorMessage("country")}
                                </div>
                            </div>

                            <div className="ask_connexion_university">
                                <div className="field">
                                    <h2>Année de diplôme</h2>
                                    <Controller
                                        name="promotionYear"
                                        control={control}
                                        render={({ field }) => (
                                            <Calendar
                                                id={field.name}
                                                {...field}
                                                className="p-inputtext p-component"
                                                view="year"
                                                dateFormat="yy"
                                            />
                                        )}
                                    />
                                    {getFormErrorMessage("name")}
                                </div>
                            </div>

                            <div className="field">
                                <h2>Niveau de diplôme *</h2>
                                {niveauDiplomeData.loaded ? (
                                    <Controller
                                        name="niveauDiplome"
                                        control={control}
                                        rules={{ required: "Le niveau de diplôme est requis" }}
                                        render={({ field }) => (
                                            <Dropdown
                                                id={field.name}
                                                placeholder="Bac, Bac+1, ..."
                                                value={field.value}
                                                options={niveauDiplomeData.data}
                                                optionLabel="label"
                                                onChange={(e) => field.onChange(e.value)}
                                            />
                                        )}
                                    />
                                ) : (
                                    <Loader></Loader>
                                )}

                                {getFormErrorMessage("niveauDiplome")}
                            </div>

                            <div className="ask_connexion_coordinates">
                                <div className="field">
                                    <h2>Adresse mail *</h2>
                                    <Controller
                                        name="email"
                                        control={control}
                                        rules={{
                                            required: "L'adresse mail est requise",
                                            pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                message: "Adresse mail invalide : example@email.com",
                                            },
                                        }}
                                        render={({ field, fieldState }) => (
                                            <InputText
                                                id={field.name}
                                                placeholder="email.test@email.com"
                                                {...field}
                                                className={classNames({
                                                    "p-invalid": fieldState.invalid,
                                                })}
                                            />
                                        )}
                                    />
                                    {getFormErrorMessage("email")}
                                </div>
                                <div className="field">
                                    <h2>Numéro de téléphone *</h2>
                                    <Controller
                                        name="telephone"
                                        control={control}
                                        rules={{
                                            required: "Le numéro de téléphone est requis.",
                                            validate: (value) =>
                                                isPossiblePhoneNumber(value) ||
                                                "Numéro de téléphone invalide",
                                        }}
                                        render={({ field }) => (
                                            <Input
                                                id={field.name}
                                                {...field}
                                                placeholder="+33 6 00 00 00 00"
                                                className="p-inputtext p-component"
                                            />
                                        )}
                                    />
                                    {getFormErrorMessage("telephone")}
                                </div>
                            </div>

                            <div className="field">
                                <h2>Motivation de la demande d&apos;inscription</h2>
                                <Controller
                                    name="motivation"
                                    control={control}
                                    render={({ field, fieldState }) => (
                                        <InputTextarea
                                            id={field.name}
                                            placeholder="Motivation de la demande d'inscription addressée aux admin"
                                            {...field}
                                            className={classNames({
                                                "p-invalid": fieldState.invalid,
                                            })}
                                        />
                                    )}
                                />
                                {getFormErrorMessage("name")}
                            </div>

                            <BtnBlanc
                                className="text-center"
                                btnTexte="Envoyer"
                                btnAction={async (e) => {
                                    e.preventDefault();
                                    const result = await trigger();
                                    if (result) setvisibleModalCharte(!visibleModalCharte);
                                }}
                            />
                        </div>
                    )}
                    {isStudent && (
                        <div className="login_alumni">
                            <div className="ask_connexion_name">
                                <div className="login__form__field">
                                    <h4 htmlFor="email">Adresse email</h4>
                                    <Controller
                                        name="login"
                                        control={control}
                                        rules={{
                                            required: "L'email est obligatoire",
                                        }}
                                        render={({ field }) => (
                                            <InputText
                                                {...field}
                                                placeholder="Adresse email"
                                                className="login__form__field-email"
                                                type="email"
                                            />
                                        )}
                                    />
                                    {getFormErrorMessage("email")}
                                </div>
                                <div className="login__form__field">
                                    <h4 htmlFor="password">Mot de passe</h4>
                                    <Controller
                                        name="password"
                                        control={control}
                                        rules={{
                                            required: "Le mot de passe est obligatoire",
                                        }}
                                        render={({ field }) => (
                                            <Password
                                                {...field}
                                                placeholder={"Mot de passe"}
                                                className="login__form__field-password"
                                                feedback={false}
                                            />
                                        )}
                                    />
                                    {getFormErrorMessage("password")}
                                </div>
                            </div>
                            <BtnBlanc
                                className="btn-submit text-center"
                                btnTexte="Envoyer"
                                btnAction={() => {
                                    onSubmit();
                                }}
                            />
                        </div>
                    )}

                </form>
                {visibleModalCharte && (
                    <ModalCharte
                        visibleModal={visibleModalCharte}
                        setVisibleModal={setvisibleModalCharte}
                        btnRefuse={() => {
                            props.setVisibleUniv(false);
                            if (props.setChosenUniversity) {
                                props.setChosenUniversity(null);
                            }
                            props.setVisibleModalGlobal && props.setVisibleModalGlobal(false);
                        }}
                        btnAction={() => {
                            onSubmit();
                        }}
                    >
                        <div className="description">
                            <ModalCharte />
                        </div>
                    </ModalCharte>
                )}
            </div>
        </div>
    );
};

AlumniUniversite.propTypes = {
    title: PropTypes.string,
    chapeau: PropTypes.string,
    bouton: PropTypes.string,
    styleFormulaireMembre: PropTypes.bool,
    utilisateur: PropTypes.any,
    auth: PropTypes.object,
    universities: PropTypes.object,
    setVisibleUniv: PropTypes.func,
    setVisibleModalGlobal: PropTypes.func,
    chosenUniversity: PropTypes.object,
    setChosenUniversity: PropTypes.func,
    handleUpdateSecondaryTables: PropTypes.func,
    handleUpdateAuth: PropTypes.func,
    secondaryTables: PropTypes.object,
    setClickedUniversity: PropTypes.func
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    universities: state.universities,
    secondaryTables: state.secondaryTables,
});

const mapDispatchToProps = (dispatch) => ({
    handleUpdateSecondaryTables: (value) => {
        dispatch(updateSecondaryTables(value));
    },
    handleUpdateAuth: (value) => {
        dispatch(updateAuth(value));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(AlumniUniversite);
